

import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import urlApi from '../actions/urlApi';

export const fetchCompetitionStage = createAsyncThunk('stage/fetchStage', async (competitionId: string) => {
    const res = await urlApi().getCompetitionStage(competitionId);
    return res;
});

export interface StageSliceState {
    stage?: `Record<string, unknown>`;
    stageLocal?: `Record<string, unknown>`;
    loading: boolean;
}

const stageSlice = createSlice({
    name: 'stage',
    initialState: {
        stage: undefined,
        stageLocal: undefined,
        loading: false,
    },
    reducers: {},
    extraReducers: {
        [fetchCompetitionStage.fulfilled.toString()]: (state, action) => {
            state.loading = false;
            state.stage = action.payload;
            // state.projectLocal = API.toLang(action.payload, i18next.language);
            state.stageLocal = action.payload;
        },
        [fetchCompetitionStage.rejected.toString()]: (state) => {
            state.loading = false;
            state.stage = undefined;
            state.stageLocal = undefined;
        },
        [fetchCompetitionStage.pending.toString()]: (state) => {
            state.loading = true;
        },
    },
});

export default stageSlice;
export const stageSliceReducer = stageSlice.reducer;
export const getStage = (store: { stage: StageSliceState }): StageSliceState => store.stage;


import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import urlApi from '../actions/urlApi';

export const fetchCompetitionStage = createAsyncThunk('stage/fetchStage', async (competitionId: string) => {
    const res = await urlApi().getCompetitionStage(competitionId);
    return res;
});

export interface StageSliceState {
    stage?: `Record<string, unknown>`;
    stageLocal?: `Record<string, unknown>`;
    loading: boolean;
}

const stageSlice = createSlice({
    name: 'stage',
    initialState: {
        stage: undefined,
        stageLocal: undefined,
        loading: false,
    },
    reducers: {},
    extraReducers: {
        [fetchCompetitionStage.fulfilled.toString()]: (state, action) => {
            state.loading = false;
            state.stage = action.payload;
            // state.projectLocal = API.toLang(action.payload, i18next.language);
            state.stageLocal = action.payload;
        },
        [fetchCompetitionStage.rejected.toString()]: (state) => {
            state.loading = false;
            state.stage = undefined;
            state.stageLocal = undefined;
        },
        [fetchCompetitionStage.pending.toString()]: (state) => {
            state.loading = true;
        },
    },
});

export default stageSlice;
export const stageSliceReducer = stageSlice.reducer;
export const getStage = (store: { stage: StageSliceState }): StageSliceState => store.stage;
